import { jsx as _jsx } from "react/jsx-runtime";
import { styled, theme } from "../theme";
import { Icon } from "../icon";
import { Button } from "../button";
const getIconSize = (buttonSize) => buttonSize === "small" ? 10 : 12;
export const DropdownMenuIconButton = ({ open, className = "", ...props }) => (_jsx(Wrapper, { className: className, children: _jsx(DropdownButton, { className: "icon-only", ...props, children: _jsx(Icon, { name: open ? "up" : "down", size: getIconSize(props.size), color: theme.color.darkBlue100 }) }) }));
const Wrapper = styled.div `
  align-items: center;
  display: inline-flex;
`;
const DropdownButton = styled(Button) `
  &.icon-only.medium {
    padding: 9px 13px 7px 13px;
  }
  &.icon-only.small {
    padding: 6px 4px 4px 11px;
  }
  &.icon-only.large {
    padding: 9px 25px 7px 25px;
    min-width: auto;
    min-height: 40px;
    height: auto;
    font-size: 16px;

    ${({ theme }) => theme.media.lg} {
      min-width: 80px;
      height: 70px;
      font-size: 20px;
    }
  }
`;
